/**
 * API Configuration
 * Update these endpoints to match your backend API
 */

const ENV = "development";

const BASE_URLS: Record<string, string> = {
  // domain: "http://192.168.1.181:5000",
  // development: "http://192.168.1.181:5000/api",
  domain: "https://backend.whitebench.co",
  development: "https://backend.whitebench.co/api",
  production: "https://pactivatebackend.packtivate.io/api",

  // domain: "https://packtivate-prod-s3-bucket.s3.ap-south-1.amazonaws.com/",
  // development: "https://pactivatebackend.packtivate.io/api",
  // production: "https://pactivatebackend.packtivate.io/api",
};

// During local Vite development, use the same-origin proxy. This lets the
// browser store and send the HttpOnly refresh cookie on localhost instead of
// treating the API host as a cross-site request.

export const API_CONFIG = {
  domain: BASE_URLS["domain"],
  baseUrl: BASE_URLS[ENV],
  endpoints: {
    auth: {
      login: "/associations/auth/login-with-pass",
      signup: "/associations/request-access",
      forgotpassword_req_otp: "/associations/auth/forgot-password/request-otp",
      forgotpassword_verifyotp: "/associations/auth/forgot-password/verify-otp",
      forgotpassword: "associations/auth/forgot-password/reset",
      resetpassword: "/associations/auth/change-password",
      refresh: "/associations/auth/refresh-token",
      logout: "/associations/auth/logout",
      verifyMfa: "/associations/auth/2fa/verify-login",
      generateMfa: "/auth/mfa/generate-setup",
      enableMfa: "/associations/auth/2fa/setup/confirm",
      disableMfa: "/associations/auth/2fa/disable",
      sendLoginOtp: "/associations/auth/login-otp/request",
      verifyLoginOtp: "/associations/auth/login-otp/verify",
    },

    dashboard: {
      getStats: "/associations/dashboard/stat-cards/:association_id",
      programmeChart:
        "/associations/dashboard/program-stat-chart/:association_id",
      calender: "associations/program-calendar/:association_id",
    },
    programme: {
      getProgrammes: "/associations/programs-list/:association_id",
      createProgrammes: "/associations/create-program",
      updateProgrammes: "/associations/update-program/:program_id",
      dropdownlist:
        "/associations/association-programs-dropdown/:associationId",
      invite: "/associations/program-invite",
      doctorDropdown: "/associations/doctors/:associationId",
      sendInvite: "/associations/program-invite",
    },

    members: {
      getstatdata: "/associations/member/stat-cards/:associationId",
      addmembers: "/associations/member/send-invite-single",
      uploadmembers: "/associations/member/send-invite",
      listMemebers: "/associations/member/list/:association_id",
      memberDetails: "/associations/member/details/:association_member_id",
      inviteMemebers: "/associations/member/invite-list/:associationId",
      memberRequests: "/associations/member/request-list/:association_id",
      updateRequest: "/associations/member/update-request-status/:request_id",
      deleteRequest: "/associations/member/delete-invite",
      resendRequest: "/associations/member/resend-member-invite",
    },

    attendance: {
      getprogrammedata: "/associations/program-invite-details/:attendanceToken",
      attendanceList: "/associations/program-attendance-list/:programId",
      updateStatus: "/associations/program-credit/manage/:programId",
      attendanceOtp: "/associations/program-attendance/send-otp",
      verifyAttendanceOtp: "/associations/program-attendance/verify-otp",
    },

    user: {
      getProfileData: "/associations/profile",
      updateProfile: "/associations/update-profile",
      passwordReset: "/associations/auth/forgot-password/reset",
      passwordResetReqOtp: "/associations/auth/forgot-password/request-otp",
      passwordResetVerifyOtp: "/associations/auth/forgot-password/verify-otp",
      setupMfa: "/associations/auth/2fa/setup",
      confirmMfa: "/associations/auth/2fa/setup/confirm",
      cancelMfa: "/associations/auth/2fa/disable",
      vertifyphonerequestotp: "/associations/update-profile/phone/request",
      vertifyphoneverifyotp: "/associations/update-profile/phone/verify",
      vertifyEmailRequestOtp: "/associations/send-verify-email",
      updateNotification:
        "associations/update-notification-settings/:association_id",
    },
  },
};

/**
 * Get full API URL
 */
export const getApiUrl = (endpoint: string): string => {
  const baseUrl = API_CONFIG.baseUrl.replace(/\/$/, "");
  const path = endpoint.replace(/^\//, "");

  return `${baseUrl}/${path}`;
};

/**
 * Replace URL parameters
 */
export const replaceUrlParams = (
  url: string,
  params: Record<string, string>,
): string => {
  let result = url;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, encodeURIComponent(value));
  });
  return result;
};
